// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"HW6_buttonsContainer__RAye3","editableSpanContainer":"HW6_editableSpanContainer__gkiTL"};